{
  "addressForm": {
    "actions": {
      "cancel": "Hủy",
      "create": "Tạo địa chỉ",
      "saveChanges": "Lưu thay đổi",
      "saving": "Đang lưu…"
    },
    "dialog": {
      "createSubtitle": "Nhập thông tin địa chỉ. Bạn có thể gán cho cửa hàng sau khi tạo.",
      "createTitle": "Thêm địa chỉ billing",
      "editSubtitle": "Lưu ý: thay đổi chỉ áp dụng cho invoice phát sinh sau. Invoice cũ giữ nguyên snapshot.",
      "editTitle": "Sửa địa chỉ billing"
    },
    "errors": {
      "createFailed": "Tạo địa chỉ thất bại (HTTP {{status}}).",
      "loadFailed": "Tải địa chỉ thất bại (HTTP {{status}}).",
      "noData": "Phản hồi không có dữ liệu địa chỉ.",
      "staleRecord": "Bản ghi đã được cập nhật ở nơi khác. Mở lại địa chỉ để lấy dữ liệu mới.",
      "unknown": "Lỗi không xác định. Vui lòng thử lại.",
      "updateFailed": "Cập nhật thất bại (HTTP {{status}})."
    },
    "fields": {
      "address": "Địa chỉ *",
      "businessName": "Tên doanh nghiệp",
      "city": "Thành phố",
      "country": "Country (ISO 2 ký tự)",
      "email": "Email *",
      "name": "Tên người nhận *",
      "phone": "SĐT",
      "state": "Tỉnh/Bang",
      "taxId": "Mã số thuế",
      "zip": "Mã bưu điện"
    },
    "loading": "Đang tải địa chỉ…",
    "placeholders": {
      "address": "123 Le Loi Street, District 1",
      "country": "VN, US, JP…"
    },
    "toast": {
      "createFailedTitle": "Tạo địa chỉ thất bại",
      "createdDesc": "Bạn có thể gán địa chỉ này cho cửa hàng từ danh sách.",
      "createdTitle": "Đã thêm địa chỉ billing",
      "updateFailedTitle": "Cập nhật thất bại",
      "updatedDesc": "Thay đổi chỉ áp dụng cho invoice mới — invoice cũ giữ nguyên.",
      "updatedTitle": "Đã cập nhật địa chỉ"
    },
    "validation": {
      "addressMax": "Địa chỉ ≤ 500 ký tự.",
      "addressRequired": "Địa chỉ bắt buộc.",
      "businessNameMax": "Tên doanh nghiệp ≤ 200 ký tự.",
      "cityMax": "Thành phố ≤ 100 ký tự.",
      "countryInvalid": "Country phải là mã ISO 2 chữ hoa (VD: VN, US).",
      "emailInvalid": "Email không hợp lệ.",
      "emailMax": "Email ≤ 254 ký tự.",
      "emailRequired": "Email bắt buộc.",
      "nameMax": "Tên ≤ 200 ký tự.",
      "nameRequired": "Tên người nhận bắt buộc.",
      "phoneMax": "SĐT ≤ 30 ký tự.",
      "stateMax": "Tỉnh/Bang ≤ 100 ký tự.",
      "taxIdMax": "Mã số thuế ≤ 50 ký tự.",
      "zipMax": "Mã bưu điện ≤ 20 ký tự."
    }
  },
  "addresses": {
    "actions": {
      "assignStores": "Gán cửa hàng",
      "cancel": "Hủy",
      "create": "+ Thêm địa chỉ",
      "delete": "Xóa",
      "edit": "Sửa",
      "retry": "Thử lại"
    },
    "confirmDelete": {
      "deleting": "Đang xóa…",
      "description": "Xóa \"{{name}}\"? Nếu đang được gán cho cửa hàng, hệ thống sẽ chặn (HTTP 409). Invoice cũ giữ nguyên snapshot — không bị ảnh hưởng.",
      "title": "Xóa địa chỉ billing?"
    },
    "empty": {
      "createButton": "+ Thêm địa chỉ đầu tiên",
      "description": "Thêm địa chỉ đầu tiên để in trên invoice. Bạn có thể tạo nhiều địa chỉ và gán cho từng cửa hàng riêng biệt.",
      "title": "Chưa có địa chỉ billing"
    },
    "errors": {
      "deleteAssigned": "Không thể xóa: địa chỉ đang được gán cho 1 hoặc nhiều cửa hàng.",
      "deleteFailed": "Xóa thất bại (HTTP {{status}}).",
      "listFailed": "Tải danh sách thất bại (HTTP {{status}}).",
      "listGeneric": "Lỗi tải danh sách.",
      "loadAddressFailed": "Tải địa chỉ thất bại (HTTP {{status}}).",
      "unknown": "Lỗi không xác định. Vui lòng thử lại."
    },
    "header": {
      "subtitle": "Quản lý địa chỉ in trên invoice. Một địa chỉ có thể gán cho nhiều cửa hàng; cửa hàng chưa gán sẽ dùng địa chỉ default.",
      "title": "Địa chỉ billing"
    },
    "pagination": {
      "first": "Trang đầu",
      "last": "Trang cuối",
      "navLabel": "Phân trang",
      "next": "Trang sau",
      "pageN": "Trang {{page}}",
      "prev": "Trang trước",
      "summary": "Hiển thị {{from}}–{{to}} của {{total}} bản ghi · Trang {{page}} / {{totalPages}}"
    },
    "sort": {
      "country": "Theo quốc gia",
      "newest": "Mới nhất",
      "oldest": "Cũ nhất"
    },
    "table": {
      "actions": "Thao tác",
      "address": "Địa chỉ",
      "assignedStores": "Cửa hàng đang gán",
      "business": "Doanh nghiệp",
      "cannotDeleteDefault": "Không thể xóa địa chỉ mặc định",
      "default": "Mặc định",
      "defaultBadge": "Mặc định",
      "recipient": "Người nhận",
      "taxId": "MST: {{taxId}}"
    },
    "toast": {
      "deleteFailedTitle": "Xóa thất bại",
      "deletedTitle": "Đã xóa địa chỉ billing"
    },
    "toolbar": {
      "sortLabel": "Sắp xếp"
    }
  },
  "alerts": {
    "card": {
      "description": "Hệ thống gửi cảnh báo khi số dư ví xuống dưới ngưỡng. Cùng giá trị ngưỡng dùng cho nạp tự động (auto-recharge — Task 20). Kênh in-app (bell + Notification Center) luôn bật theo policy P3.D-11.",
      "title": "Cảnh báo số dư thấp (Low-Balance Alert)"
    },
    "channelLabels": {
      "email": "Email",
      "inApp": "In-app",
      "inAppForced": "In-app (forced)",
      "push": "Push"
    },
    "channels": {
      "emailHint": "Gửi cảnh báo về email đăng ký của tài khoản chủ (owner). Mặc định bật.",
      "emailTitle": "Email",
      "forcedWarning": "Lưu ý: nếu tắt cả 3 kênh, in-app vẫn được gửi (forced server-side).",
      "inAppHint": "In-app luôn bật (mandatory per policy P3.D-11) — không thể tắt được.",
      "inAppTitle": "In-app (bell + Notification Center)",
      "legend": "Kênh nhận thông báo",
      "pushHint": "Yêu cầu trình duyệt cho phép thông báo. Mặc định bật.",
      "pushTitle": "Push (browser push notification)"
    },
    "errors": {
      "saveFailed": "Lưu cài đặt cảnh báo thất bại.",
      "saveFailedRetry": "Không thể lưu cài đặt cảnh báo. Vui lòng thử lại.",
      "testFailed": "Gửi test alert thất bại.",
      "testRateLimited": "Đã gửi test alert quá nhanh. Vui lòng đợi 1 phút rồi thử lại.",
      "testSuspended": "Tài khoản đang tạm dừng (suspended). Không thể gửi test alert.",
      "testThresholdNotConfigured": "Cấu hình ngưỡng số dư trước (threshold > 0) rồi mới gửi test alert."
    },
    "form": {
      "saveButton": "Lưu cài đặt",
      "saving": "Đang lưu…",
      "sendTestButton": "Gửi test alert (1 lần / phút)",
      "sendingTest": "Đang gửi…",
      "testDisabledHint": "Cấu hình ngưỡng số dư trước khi gửi test alert.",
      "thresholdHelp": "Khi số dư xuống dưới ngưỡng (cross downward) → gửi cảnh báo 1 lần. Khi nạp lên trên rồi xuống lại → gửi lại. Để trống = dùng ngưỡng mặc định của hệ thống ({{state}}).",
      "thresholdLabel": "Ngưỡng cảnh báo (USD)",
      "thresholdPlaceholderEnvDefault": "Đang dùng mặc định hệ thống",
      "thresholdPlaceholderExample": "VD: 50",
      "thresholdStateApplying": "đang áp dụng",
      "thresholdStateOverride": "sẽ ghi đè"
    },
    "suspended": {
      "readOnlyNotice": "Tài khoản đang tạm dừng (suspended). Mọi cài đặt đang ở chế độ chỉ-đọc."
    },
    "toast": {
      "rateLimitedTitle": "Vượt giới hạn (1 lần/phút)",
      "saveFailedTitle": "Lưu thất bại",
      "savedDesc": "Cài đặt cảnh báo số dư đã được cập nhật.",
      "savedTitle": "Đã lưu",
      "testFailedTitle": "Gửi test alert thất bại",
      "testSentDesc": "Kênh đã gửi: {{channels}}.",
      "testSentTitle": "Đã gửi test alert"
    },
    "validation": {
      "thresholdNonNegative": "Ngưỡng cảnh báo (threshold — số dư tối thiểu) phải là số không âm."
    }
  },
  "assignStores": {
    "assigned": {
      "empty": "Chưa có cửa hàng nào — store chưa gán sẽ fallback về địa chỉ default.",
      "heading": "Cửa hàng đang gán ({{count}})"
    },
    "buttons": {
      "cancel": "Hủy",
      "submit": "Gán {{count}} cửa hàng",
      "submitting": "Đang gán…"
    },
    "counts": {
      "invalid": "Không hợp lệ: {{count}}",
      "max": "Tối đa: 50",
      "valid": "Hợp lệ: {{count}}"
    },
    "errors": {
      "assignFailedHttp": "Gán cửa hàng thất bại (HTTP {{status}}).",
      "invalidIds": "Có {{count}} ID không hợp lệ. ID phải là UUID hoặc 24-char hex (ObjectId).",
      "maxFifty": "Chỉ có thể gán tối đa 50 cửa hàng cùng lúc.",
      "minOne": "Vui lòng nhập ít nhất 1 store ID hợp lệ.",
      "noAddress": "Không tìm thấy địa chỉ billing.",
      "unknown": "Lỗi không xác định. Vui lòng thử lại."
    },
    "fallbackNote": "Cửa hàng vắng mặt sẽ rơi về địa chỉ default.",
    "input": {
      "label": "Store IDs (UUID hoặc 24-char hex, mỗi ID một dòng hoặc cách bằng dấu phẩy)"
    },
    "replaceNote": "Submit sẽ thay thế toàn bộ assignment cho địa chỉ này (replace semantics).",
    "subtitle": {
      "default": "Chọn cửa hàng sẽ dùng địa chỉ này trên invoice.",
      "withLabel": "Địa chỉ: {{label}}"
    },
    "title": "Gán cửa hàng cho địa chỉ billing",
    "toast": {
      "errorTitle": "Gán cửa hàng thất bại",
      "successDescription": "Các cửa hàng được gán cho địa chỉ billing này.",
      "successTitle": "Đã cập nhật assignment"
    }
  },
  "autoPay": {
    "card": {
      "description": "Cấu hình tự động trừ ví khi tạo đơn. Áp dụng cho đơn hàng (order), phụ phí (surcharge — phí phát sinh do admin cộng thêm), phí số hoá mũi thêu (digitize fee), và phí thêu (embroidery fee). Khi tắt, đơn vẫn được tạo ở trạng thái chưa thanh toán (unpaid) và bạn cần thanh toán thủ công.",
      "title": "Thanh toán tự động (auto-pay)"
    },
    "errors": {
      "network": "Đã xảy ra lỗi mạng (network error — kiểm tra kết nối).",
      "persistence": "Lưu chưa được xác nhận từ máy chủ (persistence check failed — kiểm tra dấu hiệu ghost-save). Vui lòng thử lại.",
      "suspended": "Tài khoản đang bị tạm dừng — không thể cập nhật cấu hình thanh toán tự động (auto-pay)."
    },
    "loadError": {
      "generic": "lỗi không xác định",
      "label": "Không tải được cấu hình hiện tại: {{message}}"
    },
    "master": {
      "help": "Khi bật, hệ thống tự động trừ tiền từ nguồn được chọn bên dưới ngay khi đơn được tạo. Đơn không đủ tiền sẽ chuyển sang chờ thanh toán (pending_payment) và tự động thử lại (auto retry) khi ví có thêm tiền.",
      "label": "Bật thanh toán tự động"
    },
    "mode": {
      "legend": "Nguồn tiền (funding source)",
      "rule": "Quy tắc: 1 nguồn phải đủ TOÀN BỘ đơn hàng — hệ thống không chia nhỏ thanh toán (no split payment). Ví dụ: đơn {{order}}, ví {{wallet}} + tín dụng (credit) {{credit}} → đơn vẫn unpaid vì không có nguồn nào đủ một mình.",
      "walletOnly": {
        "hint": "Chỉ trừ ví. Nếu ví không đủ → đơn unpaid.",
        "label": "Chỉ ví (wallet only)"
      },
      "walletPlusCredit": {
        "hint": "Thử ví trước; nếu ví không đủ TOÀN BỘ đơn, hệ thống thử trừ từ tín dụng (credit) — vẫn theo nguyên tắc 1 nguồn đủ toàn bộ.",
        "label": "Ví + Tín dụng (wallet + credit)"
      }
    },
    "notify": {
      "email": "Email",
      "help": "Tắt nếu bạn xử lý nhiều đơn và muốn tránh spam thông báo. Hệ thống vẫn có thể gộp nhiều đơn thành 1 thông báo (notification batch) khi cần.",
      "inApp": "In-app (chuông thông báo trên TopBar)",
      "legend": "Thông báo khi auto-pay thành công"
    },
    "submit": {
      "loading": "Đang tải…",
      "save": "Lưu cấu hình",
      "saving": "Đang lưu…",
      "suspendedTitle": "Tài khoản bị tạm dừng — không thể lưu"
    },
    "success": "Đã lưu cấu hình thanh toán tự động.",
    "suspendedBanner": "Tài khoản đang bị tạm dừng (suspended) — chỉ xem, không sửa được cấu hình."
  },
  "autoRecharge": {
    "actions": {
      "save": "Lưu cài đặt",
      "saving": "Đang lưu…"
    },
    "card": {
      "description": "Tự động nạp tiền vào ví khi số dư xuống dưới ngưỡng kích hoạt (threshold — số dư tối thiểu). Áp dụng đơn hàng, phụ phí, phí số hóa và phí thêu.",
      "title": "Nạp tự động (Auto-Recharge)"
    },
    "disabledBanner": "Hệ thống đã tự tắt nạp tự động do nhiều lần thất bại liên tiếp. Kiểm tra phương thức thanh toán và bật lại thủ công.",
    "fields": {
      "amountHelp": "Phải lớn hơn hoặc bằng ngưỡng kích hoạt và tối thiểu {{min}}.",
      "amountLabel": "Số tiền nạp mỗi lần (USD)",
      "amountPlaceholder": "Tối thiểu {{min}}",
      "enabledLabel": "Bật nạp tự động",
      "maxPerDayHelp": "Cấu hình bởi quản trị viên (admin). Vượt giới hạn → nạp tự động sẽ tự tắt và gửi thông báo.",
      "maxPerDayLabel": "Giới hạn nạp tự động mỗi ngày",
      "maxPerDayValue": "{{limit}} lần / ngày",
      "methodDefaultSuffix": " (mặc định)",
      "methodLabel": "Phương thức thanh toán",
      "methodNone": "— Chưa chọn —",
      "thresholdHelp": "Khi số dư ví xuống dưới mức này, hệ thống sẽ kích hoạt nạp tự động. Cùng giá trị này dùng cho cảnh báo số dư thấp (low-balance alert).",
      "thresholdLabel": "Ngưỡng kích hoạt (USD)",
      "thresholdPlaceholder": "VD: 50"
    },
    "noMethod": {
      "linkText": "Phương thức thanh toán",
      "prefix": "Chưa có phương thức thanh toán đủ điều kiện. Vào ",
      "suffix": " để liên kết PayPal / Stripe / Payoneer / LianLian."
    },
    "toast": {
      "saveErrorDesc": "Không thể lưu cài đặt nạp tự động. Vui lòng thử lại.",
      "saveErrorTitle": "Lưu thất bại",
      "saveSuccessDesc": "Cài đặt nạp tự động đã được cập nhật.",
      "saveSuccessTitle": "Đã lưu"
    },
    "toggle": {
      "disabledHint": "Đang tắt — cần nạp thủ công khi số dư thấp.",
      "enabledHint": "Đã bật — hệ thống sẽ tự động nạp khi số dư xuống dưới ngưỡng.",
      "needMethodTooltip": "Cần liên kết phương thức thanh toán hỗ trợ server-to-server (PayPal / Stripe / Payoneer / LianLian) trước khi bật nạp tự động."
    },
    "validation": {
      "amountGteThreshold": "Số tiền nạp (amount — số USD nạp mỗi lần) phải lớn hơn hoặc bằng ngưỡng kích hoạt.",
      "amountMin": "Số tiền nạp phải tối thiểu {{min}} (mức tối thiểu hệ thống).",
      "needLinkedMethod": "Cần liên kết phương thức thanh toán (linked payment method — tài khoản cổng đã xác thực) trước khi bật nạp tự động.",
      "selectMethod": "Vui lòng chọn phương thức thanh toán cho nạp tự động.",
      "thresholdPositive": "Ngưỡng kích hoạt (threshold — số dư tối thiểu) phải lớn hơn 0."
    }
  },
  "billingLayout": {
    "actions": {
      "generateReport": "Tạo báo cáo",
      "generateReportAria": "Tạo báo cáo tài chính",
      "topUp": "+ Nạp ví",
      "topUpAria": "Nạp tiền vào ví"
    },
    "header": {
      "subtitle": "Quản lý hóa đơn, nạp tiền và báo cáo hoàn tất đơn",
      "title": "Tổng quan tài chính"
    },
    "kpi": {
      "autoTopup": {
        "label": "Trạng thái nạp tự động",
        "off": "Tắt",
        "offHint": "Tắt — bật để nạp tự động",
        "on": "Đang bật",
        "onHint": "Khi balance < {{threshold}} → nạp {{topup}}"
      },
      "balance": {
        "label": "Số dư ví",
        "loading": "Đang tải ví…",
        "pendingTopup": "Đang chờ nạp {{amount}}"
      },
      "pendingInvoices": {
        "label": "Hóa đơn chờ thanh toán",
        "subLabel": "{{amount}} chờ thanh toán"
      },
      "spending": {
        "label": "Chi tiêu tháng này",
        "subLabel": "30 ngày gần nhất (MTD)"
      }
    },
    "settingsPlaceholder": {
      "suffix": ".",
      "text": "Cài đặt billing (auto-pay, auto-recharge, low balance alert, invoice schedule, billing addresses, payment methods, 2FA) — Wave 6 Task 17/18. Tạm thời truy cập rời tại "
    },
    "tabs": {
      "ariaLabel": "Các mục tài chính",
      "settings": "Cấu hình",
      "transactions": "Giao dịch"
    },
    "transactionsPlaceholder": {
      "suffix": ".",
      "text": "Lịch sử giao dịch chi tiết — Wave 6 Task 17 (transactions table + filter chips + invoice action). Hiện tại xem ví đầy đủ tại "
    },
    "walletError": "Không tải được ví ({{message}}).",
    "walletErrorUnknown": "lỗi không xác định"
  },
  "billingPage": {
    "description": "Theo dõi credit (tín dụng) và dư nợ. Phase 3.5 sẽ bổ sung wallet, giao dịch, và sao kê.",
    "title": "Billing (Tổng quan tài chính)"
  },
  "creditCard": {
    "daysValue": "{{count}} ngày",
    "debt": {
      "current": "Dư nợ hiện tại: {{amount}}.",
      "none": "Hiện chưa có dư nợ phải trả."
    },
    "fields": {
      "daysLeft": "Ngày còn lại",
      "limit": "Hạn mức",
      "remaining": "Còn lại"
    },
    "payCta": "Trả nợ",
    "status": {
      "active": "Đang hoạt động",
      "expired": "Hết hạn",
      "overdue": "Quá hạn",
      "revoked": "Đã thu hồi"
    },
    "title": "Credit (Tín dụng)"
  },
  "invoiceDetail": {
    "actions": {
      "dispute": "Khiếu nại",
      "downloadPdf": "Tải PDF",
      "downloadPdfAria": "Tải PDF",
      "downloading": "Đang tải…",
      "pay": "Thanh toán {{amount}}"
    },
    "bank": {
      "accountHolder": "Chủ tài khoản",
      "accountNumber": "Số tài khoản",
      "accountType": "Loại tài khoản",
      "bankAddress": "Địa chỉ ngân hàng",
      "bankCode": "Mã ngân hàng",
      "bankName": "Tên ngân hàng",
      "branchCode": "Mã chi nhánh",
      "heading": "Tài khoản ngân hàng",
      "subtitle": "Thông tin chuyển khoản cho {{name}}.",
      "swiftCode": "Mã SWIFT",
      "walletsHeading": "Ví khác được chấp nhận"
    },
    "detailError": {
      "backToInvoices": "Quay lại danh sách hoá đơn",
      "loadFailed": "Không tải được hoá đơn",
      "retry": "Thử lại"
    },
    "download": {
      "failedHttp": "Tải PDF thất bại (HTTP {{status}})",
      "failedTitle": "Tải xuống thất bại",
      "networkError": "Lỗi mạng - kiểm tra kết nối",
      "notReady": "Hoá đơn vẫn ở trạng thái nháp — PDF chưa được kết xuất."
    },
    "gateway": {
      "airwallex": "Airwallex",
      "bank": "Chuyển khoản ngân hàng",
      "lianlian": "LianLian",
      "manual": "Thủ công",
      "payoneer": "Payoneer",
      "paypal": "PayPal",
      "pingpong": "PingPong",
      "stripe": "Stripe",
      "sunrate": "Sunrate",
      "worldfirst": "WorldFirst"
    },
    "header": {
      "backToInvoices": "Quay lại danh sách hoá đơn",
      "cycleLabel": "Kỳ {{start}} → {{end}}",
      "netTerms": " · Công nợ (hạn {{date}})",
      "title": "Hoá đơn {{number}}"
    },
    "help": {
      "contactSupport": "Liên hệ hỗ trợ",
      "heading": "Cần trợ giúp?",
      "question": "Có thắc mắc về hoá đơn này?"
    },
    "lineItems": {
      "colDescription": "Mô tả",
      "colQty": "SL",
      "colTotal": "Thành tiền",
      "colUnit": "Đơn giá",
      "empty": "Không có dòng nào.",
      "heading": "Chi tiết dòng",
      "subtotal": "Tạm tính",
      "tax": "Thuế",
      "totalDue": "Tổng phải trả"
    },
    "notFound": {
      "backToInvoices": "Quay lại danh sách hoá đơn",
      "message": "Không tìm thấy hoá đơn."
    },
    "payDialog": {
      "ariaLabel": "Gửi thanh toán",
      "bodyAfter": "(Task 47, Wave 15). Hộp thoại này giữ test ID để luồng thanh toán vẫn truy cập được trong khi component chuẩn đang được đấu nối.",
      "bodyBefore": "Biểu mẫu gửi thanh toán đầy đủ (cổng thanh toán, số tiền, mã tham chiếu, tải lên bằng chứng, ghi chú) được cung cấp bởi component dùng chung",
      "cancel": "Huỷ",
      "close": "Đóng",
      "submit": "Tiếp tục thanh toán",
      "subtitle": "Hoá đơn {{number}} · Còn lại {{amount}}",
      "title": "Gửi thanh toán"
    },
    "payment": {
      "dueLabel": "Hạn:",
      "heading": "Thanh toán",
      "paidLabel": "Đã trả:",
      "payNow": "Thanh toán ngay",
      "payNowAria": "Thanh toán ngay"
    },
    "paymentStatus": {
      "APPROVED": "Đã duyệt",
      "PENDING_APPROVAL": "Chờ duyệt",
      "REJECTED": "Bị từ chối",
      "REVERSED": "Đã hoàn tác"
    },
    "payments": {
      "colAmount": "Số tiền",
      "colGateway": "Cổng thanh toán",
      "colReference": "Mã tham chiếu",
      "colStatus": "Trạng thái",
      "colSubmitted": "Đã gửi",
      "heading": "Lịch sử thanh toán"
    },
    "preview": {
      "heading": "Xem trước hoá đơn",
      "iframeTitle": "Xem trước hoá đơn {{number}}",
      "subtitle": "Kết xuất từ mẫu PDF mới nhất."
    },
    "status": {
      "DRAFT": "Nháp",
      "OVERDUE": "Quá hạn",
      "PAID": "Đã thanh toán",
      "PARTIAL": "Thanh toán một phần",
      "PENDING_APPROVAL": "Chờ duyệt",
      "SENT": "Chờ thanh toán",
      "VOIDED": "Đã huỷ"
    }
  },
  "invoiceList": {
    "errors": {
      "loadTitle": "Lỗi tải invoice",
      "unknown": "Lỗi không xác định"
    },
    "filters": {
      "dueBeforeAria": "Hạn trước ngày",
      "searchAria": "Tìm invoice theo số hoặc tháng",
      "searchPlaceholder": "Số hoá đơn hoặc tháng…",
      "statusAria": "Lọc theo trạng thái"
    },
    "forbidden": {
      "backHome": "Về trang chủ",
      "body": "Trang Invoices (hoá đơn) chỉ truy cập được bởi chủ merchant. Nếu bạn cần xem hoá đơn, vui lòng liên hệ owner để xin chuyển scope hoặc cấp quyền tương ứng (TS-34).",
      "title": "Chỉ dành cho chủ sở hữu"
    },
    "header": {
      "subtitle": "Các kỳ thanh toán trước đây và hiện tại. Hoá đơn Net-Terms được phát hành tự động theo cycle merchant đã cấu hình.",
      "title": "Hoá đơn của tôi"
    },
    "pagination": {
      "next": "Trang sau",
      "prev": "Trang trước",
      "summary": "Hiển thị {{from}}–{{to}} trên {{total}} invoice · Trang {{page}} / {{totalPages}}"
    },
    "payDisabled": {
      "DRAFT": "Hoá đơn nháp",
      "PAID": "Đã thanh toán",
      "PENDING_APPROVAL": "Chờ admin duyệt",
      "VOIDED": "Hoá đơn đã huỷ",
      "default": "Không thể thanh toán"
    },
    "payModal": {
      "ariaLabel": "Biểu mẫu gửi thanh toán",
      "bodyAfter": ".",
      "bodyBefore": "Form chi tiết (gateway / số tiền / proof_file / notes) đang được phát triển trong Task 47 cùng wave (Wave 15). Sau khi sibling commit, placeholder này sẽ được thay bằng",
      "closeAria": "Đóng",
      "closeButton": "Đóng",
      "remaining": "Còn lại {{amount}} cần thanh toán.",
      "title": "Gửi thanh toán — {{number}}"
    },
    "statusBadge": {
      "DRAFT": "Nháp",
      "OVERDUE": "Quá hạn",
      "PAID": "Đã trả",
      "PARTIAL": "Một phần",
      "PENDING_APPROVAL": "Chờ duyệt",
      "SENT": "Đã gửi",
      "VOIDED": "Đã huỷ"
    },
    "statusFilter": {
      "OVERDUE": "Quá hạn",
      "PAID": "Đã thanh toán",
      "PARTIAL": "Thanh toán một phần",
      "PENDING_APPROVAL": "Chờ duyệt",
      "SENT": "Đã gửi (Sent)",
      "all": "Tất cả"
    },
    "table": {
      "colActions": "Thao tác",
      "colAmount": "Số tiền",
      "colCycle": "Kỳ",
      "colDue": "Hạn",
      "colInvoice": "Số hoá đơn",
      "colStatus": "Trạng thái",
      "empty": "Chưa có invoice nào trong scope hiện tại.",
      "loading": "Đang tải invoices…",
      "pay": "Thanh toán",
      "pdf": "PDF",
      "retry": "Thử lại"
    }
  },
  "invoices": {
    "detail": {
      "ariaLabel": "Chi tiết invoice",
      "billingAddress": "Bên nhận (billing address)",
      "close": "Đóng",
      "colDescription": "Mô tả",
      "colLineTotal": "Thành tiền",
      "colQty": "SL",
      "colUnitPrice": "Đơn giá",
      "downloadPdf": "Tải PDF",
      "downloadingPdf": "Đang tải…",
      "errorPrefix": "Lỗi tải chi tiết: {{message}}",
      "grandTotal": "Tổng tiền",
      "issuedAt": "Phát hành {{date}}",
      "legalEntity": "Bên phát hành (legal entity)",
      "lineItems": "Chi tiết dòng (line items)",
      "loading": "Đang tải chi tiết invoice…",
      "mst": "MST: {{value}}",
      "noLines": "Không có dòng nào.",
      "period": "Kỳ thanh toán",
      "retry": "Thử lại",
      "subtotal": "Tạm tính",
      "taxId": "Mã số thuế: {{value}}",
      "titleFallback": "Chi tiết invoice (hoá đơn)",
      "totals": "Tổng cộng"
    },
    "filters": {
      "dateFrom": "Từ ngày",
      "dateTo": "Đến ngày",
      "sort": "Sắp xếp",
      "sortOptions": {
        "newest": "Mới nhất",
        "oldest": "Cũ nhất",
        "totalAsc": "Tổng tiền (thấp → cao)"
      },
      "status": "Trạng thái",
      "statusAll": "Tất cả"
    },
    "list": {
      "empty": "Chưa có invoice nào — invoice tự động phát hành theo cron Phase 4.1 (chu kỳ tháng).",
      "errorPrefix": "Lỗi tải dữ liệu: {{message}}",
      "loading": "Đang tải invoices…",
      "retry": "Thử lại"
    },
    "page": {
      "description": "Danh sách hoá đơn theo kỳ. Tải PDF để in ấn / lưu trữ. Hoá đơn được phát hành tự động theo cron Phase 4.1.",
      "title": "Hoá đơn"
    },
    "pagination": {
      "next": "Trang sau",
      "prev": "Trang trước",
      "showing": "Hiển thị {{from}}–{{to}} trên {{total}} invoice · Trang {{page}} / {{totalPages}}"
    },
    "status": {
      "cancelled": "Đã huỷ",
      "draft": "Nháp",
      "issued": "Đã phát hành",
      "paid": "Đã thanh toán"
    },
    "table": {
      "actions": "Hành động",
      "issuedAt": "Ngày phát hành",
      "loadingPdf": "Đang tải…",
      "number": "Số invoice",
      "pdf": "PDF",
      "period": "Kỳ",
      "status": "Trạng thái",
      "total": "Tổng tiền",
      "view": "Xem"
    },
    "toast": {
      "pdfFailedTitle": "Tải PDF thất bại",
      "pdfPendingDesc": "Hệ thống đang sinh PDF cho invoice này. Vui lòng thử lại sau khoảng 30 giây.",
      "pdfPendingTitle": "PDF đang được tạo",
      "pdfServerError": "Lỗi máy chủ (HTTP {{status}})."
    }
  },
  "limitRequestHistory": {
    "cancel": "Huỷ",
    "cancelToast": {
      "errorTitle": "Không thể huỷ yêu cầu",
      "successDescription": "Yêu cầu đã chuyển sang trạng thái Cancelled.",
      "successTitle": "Đã huỷ yêu cầu"
    },
    "columns": {
      "actions": "Hành động",
      "amount": "Số tiền",
      "reason": "Lý do",
      "requestedAt": "Yêu cầu lúc",
      "reviewNote": "Ghi chú duyệt",
      "reviewedAt": "Duyệt lúc",
      "status": "Trạng thái"
    },
    "confirmCancel": {
      "confirmLabel": "Huỷ yêu cầu",
      "description": "Hành động này không thể hoàn tác. Bạn có thể tạo yêu cầu mới sau khi huỷ.",
      "title": "Huỷ yêu cầu {{amount}}?"
    },
    "createFirst": "Tạo yêu cầu đầu tiên",
    "empty": "Chưa có yêu cầu nào.",
    "heading": "Lịch sử yêu cầu hạn mức",
    "loadError": "Lỗi tải lịch sử: {{message}}",
    "loadMore": "Tải thêm",
    "loading": "Đang tải lịch sử yêu cầu…",
    "requestMore": "Yêu cầu thêm",
    "retry": "Thử lại",
    "status": {
      "approved": "Đã duyệt",
      "cancelled": "Đã huỷ",
      "expired": "Hết hạn",
      "pending": "Chờ duyệt",
      "rejected": "Từ chối"
    },
    "subheading": "Yêu cầu mới nhất ở trên cùng. Yêu cầu pending có thể huỷ."
  },
  "limitRequestModal": {
    "actions": {
      "cancel": "Hủy",
      "submit": "Gửi yêu cầu",
      "submitting": "Đang gửi…"
    },
    "amount": {
      "hint": "Tối thiểu $1.00 — nhập theo USD.",
      "label": "Số tiền muốn tăng (USD)"
    },
    "duration": {
      "error": "Thời hạn phải nằm trong khoảng 1–365 ngày.",
      "label": "Thời hạn áp dụng (ngày, 1–365)"
    },
    "durationPreset": "{{days}}d",
    "errors": {
      "invalidAmount": "Số tiền không hợp lệ — tối thiểu $1.00.",
      "invalidPayload": "Invalid payload",
      "payloadField": "payload",
      "pendingExists": "Bạn đã có 1 request chờ duyệt — hủy request cũ trước (xem mục History bên dưới).",
      "submitFallback": "Lỗi gửi yêu cầu."
    },
    "reason": {
      "error": "Mô tả tối thiểu {{min}} ký tự, tối đa {{max}}.",
      "hint": "Giải thích ngắn gọn lý do cần tăng hạn mức.",
      "label": "Lý do (tối thiểu {{min}} ký tự)",
      "placeholder": "VD: Cần chi cho campaign Tết — đã được leader approve qua Slack."
    },
    "title": "Yêu cầu tăng hạn mức chi tiêu",
    "toast": {
      "error": {
        "title": "Lỗi gửi yêu cầu"
      },
      "pending": {
        "description": "Hủy request cũ trước (xem mục History bên dưới).",
        "title": "Bạn đã có 1 request chờ duyệt"
      },
      "success": {
        "description": "Team Lead sẽ xem xét trong thời gian sớm nhất.",
        "title": "Yêu cầu đã gửi"
      }
    }
  },
  "memberBilling": {
    "cards": {
      "remaining": {
        "label": "Còn lại"
      },
      "total": {
        "label": "Hạn mức tổng",
        "noLimit": "Chưa cấp hạn mức",
        "periodSubLabel": "Kỳ: {{period}}"
      },
      "usagePct": {
        "label": "% Đã dùng"
      },
      "used": {
        "label": "Đã dùng"
      }
    },
    "emptyBanner": {
      "cta": "Yêu cầu thêm",
      "description": "Yêu cầu thêm hạn mức để tiếp tục thanh toán đơn.",
      "title": "Bạn đã dùng hết hạn mức kỳ này"
    },
    "error": {
      "message": "Lỗi tải hạn mức: {{message}}",
      "retry": "Thử lại"
    },
    "header": {
      "description": "Theo dõi hạn mức được cấp, mức đã chi và yêu cầu thêm hạn mức khi cần.",
      "title": "Hạn mức & Chi tiêu"
    },
    "loading": "Đang tải hạn mức…",
    "overview": {
      "requestMore": "Yêu cầu thêm hạn mức",
      "title": "Tổng quan kỳ này"
    },
    "period": {
      "biweekly": "Hai tuần",
      "daily": "Hằng ngày",
      "monthly": "Hằng tháng",
      "quarter": "Hằng quý",
      "weekly": "Hằng tuần"
    },
    "periodTabs": {
      "ariaLabel": "Chọn kỳ hạn mức"
    },
    "transactions": {
      "placeholder": "Sẽ khả dụng khi Phase 3.5 hoàn tất sổ cái phía thành viên.",
      "title": "Lịch sử giao dịch"
    }
  },
  "merchantPay": {
    "actions": {
      "cancel": "Hủy",
      "submit": "Gửi thanh toán",
      "submitting": "Đang gửi…",
      "uploading": "Đang tải chứng từ lên…"
    },
    "amount": {
      "hint": "Toàn bộ số tiền: {{amount}} · Cho phép thanh toán một phần: có",
      "label": "Số tiền (USD)"
    },
    "errors": {
      "amountExceedsFallback": "Số tiền vượt quá số dư còn lại.",
      "amountInvalidDecimals": "Số tiền phải là giá trị USD dương với tối đa 2 chữ số thập phân.",
      "gatewayNotEnabled": "Cổng đã chọn chưa được bật cho pháp nhân này.",
      "proofRequired": "Bắt buộc có chứng từ",
      "referenceAlreadyUsed": "Mã tham chiếu đã được sử dụng",
      "submitFailedHttp": "Gửi thất bại (HTTP {{status}}).",
      "submitFailedTitle": "Gửi thất bại",
      "unexpected": "Lỗi không mong muốn."
    },
    "file": {
      "mimeReject": "Chỉ PDF, PNG, JPG.",
      "sizeReject": "Tối đa 5MB."
    },
    "gateway": {
      "label": "Cổng thanh toán",
      "placeholder": "Chọn một cổng…"
    },
    "idempotencyNotice": "Thao tác này gửi chứng từ thanh toán để kế toán xét duyệt. Gửi hai lần trong vòng 30 giây sẽ được khử trùng lặp bằng Idempotency-Key.",
    "noMethods": "Chưa có cổng thanh toán nào được bật cho pháp nhân này. Vui lòng liên hệ bộ phận hỗ trợ để cấu hình trước khi gửi thanh toán.",
    "notes": {
      "label": "Ghi chú (tùy chọn)",
      "placeholder": "Chuyển khoản ngân hàng do kế toán thực hiện — vui lòng xác minh"
    },
    "proof": {
      "browse": "chọn tệp",
      "constraints": "Tối đa 5MB · Chỉ PDF, PNG, JPG",
      "dropInstruction": "Kéo thả biên lai ngân hàng PDF/PNG vào đây, hoặc",
      "label": "Chứng từ thanh toán",
      "replace": "Thay tệp khác"
    },
    "reference": {
      "placeholder": "WIRE-OUT-20260430-MRCH-7"
    },
    "referenceLabel": {
      "airwallex": "Mã giao dịch Airwallex",
      "bank": "Mã tham chiếu SWIFT",
      "default": "Mã tham chiếu thanh toán",
      "lianlian": "Mã chuyển khoản LianLian",
      "payoneer": "Mã giao dịch Payoneer",
      "paypal": "Mã giao dịch PayPal",
      "pingpong": "Mã chuyển khoản PingPong",
      "stripe": "Mã giao dịch Stripe",
      "sunrate": "Mã chuyển khoản SunRate",
      "worldfirst": "Mã chuyển khoản WorldFirst"
    },
    "subtitle": "Thanh toán hóa đơn {{invoiceNumber}} — {{amount}}",
    "success": {
      "description": "Đang chờ kế toán xét duyệt — hóa đơn hiện ở trạng thái Chờ duyệt.",
      "title": "Đã gửi thanh toán"
    },
    "title": "Gửi thanh toán",
    "upload": {
      "failed": "Tải chứng từ lên thất bại.",
      "failedHttp": "Tải lên thất bại (HTTP {{status}})",
      "networkError": "Lỗi mạng trong khi tải lên.",
      "noUrl": "Dịch vụ tải lên không trả về URL — vui lòng thử lại hoặc liên hệ hỗ trợ."
    },
    "validation": {
      "amountExceeds": "Số tiền vượt quá số dư còn lại ({{amount}}).",
      "amountInvalid": "Số tiền phải là giá trị USD dương (tối đa 2 chữ số thập phân).",
      "gatewayRequired": "Vui lòng chọn cổng thanh toán.",
      "notesTooLong": "Ghi chú ≤ 500 ký tự.",
      "proofRequired": "Bắt buộc có chứng từ",
      "referenceRequired": "Bắt buộc nhập mã tham chiếu.",
      "referenceTooLong": "Mã tham chiếu ≤ 120 ký tự."
    }
  },
  "outstandingWidget": {
    "aria": {
      "due": "hạn thanh toán {{date}}",
      "outstanding": "Còn nợ {{amount}}"
    },
    "due": {
      "label": "Hạn {{date}}"
    },
    "relativeDays": {
      "inDays": "trong {{count}} ngày",
      "overdueDays": "đã quá hạn {{count}} ngày",
      "overdueOneDay": "đã quá hạn 1 ngày",
      "today": "hôm nay",
      "tomorrow": "ngày mai"
    }
  },
  "overdueBanner": {
    "dismissAria": "Đóng thông báo",
    "many": {
      "after": "). Vui lòng thanh toán để tiếp tục đặt đơn.",
      "before": "Bạn có ",
      "middle": " hoá đơn quá hạn (hoá đơn cũ nhất hết hạn ngày "
    },
    "one": {
      "after": "). Vui lòng thanh toán để tiếp tục đặt đơn.",
      "before": "Bạn có 1 hoá đơn quá hạn (hết hạn ngày "
    },
    "viewInvoices": "Xem hoá đơn"
  },
  "payCredit": {
    "actions": {
      "cancel": "Hủy",
      "submit": "Xác nhận trả",
      "submitting": "Đang xử lý…"
    },
    "amountHint": "Tối thiểu $1.00 — tối đa {{max}}.",
    "amountLabel": "Số tiền ($)",
    "currentDebt": "Nợ hiện tại",
    "errors": {
      "invalidAmount": "Số tiền không hợp lệ.",
      "overdueLocked": "Credit đã bị khóa do quá hạn — nợ {{debt}} (đến hạn {{dueDate}}). Liên hệ admin để mở khóa.",
      "unknown": "Lỗi không xác định.",
      "walletInsufficient": "Wallet không đủ — số dư đã thay đổi. Vui lòng tải lại trang và thử lại."
    },
    "insufficientNotice": "Wallet không đủ — chỉ có thể trả tối đa",
    "payFull": "Trả toàn bộ",
    "title": "Trả nợ Credit",
    "toast": {
      "successDescription": "Đã trả {{amount}} — số dư mới đã được cập nhật.",
      "successTitle": "Đã trả Credit"
    },
    "topupCta": "Nạp thêm tiền",
    "walletBalance": "Số dư wallet"
  },
  "paymentRequests": {
    "create": {
      "amount": "Số tiền",
      "ariaLabel": "Tạo yêu cầu thanh toán",
      "cancel": "Huỷ",
      "charCount": "{{count}}/{{max}} ký tự",
      "description": "Yêu cầu hoàn tiền hoặc tín dụng off-platform từ Printway. Admin sẽ duyệt trong 1–2 ngày làm việc.",
      "purpose": "Lý do (purpose)",
      "purposePlaceholder": "Mô tả chi tiết lý do yêu cầu (tối thiểu 10 ký tự, tối đa 500)…",
      "submit": "Tạo yêu cầu",
      "submitting": "Đang gửi…",
      "title": "Tạo payment request (yêu cầu thanh toán) mới"
    },
    "createButton": "+ Tạo yêu cầu",
    "detail": {
      "adminDecided": "Admin xử lý — {{status}}",
      "amount": "Số tiền",
      "ariaLabel": "Chi tiết payment request",
      "awaitingAdmin": "Đang chờ admin xử lý…",
      "close": "Đóng",
      "createdAt": "Tạo {{date}}",
      "history": "Lịch sử trạng thái",
      "purpose": "Lý do",
      "submitted": "Đã gửi yêu cầu"
    },
    "filters": {
      "sort": "Sắp xếp",
      "sortOptions": {
        "newest": "Mới nhất",
        "oldest": "Cũ nhất",
        "status": "Theo trạng thái"
      },
      "status": "Trạng thái",
      "statusAll": "Tất cả"
    },
    "list": {
      "empty": "Chưa có payment request nào — bấm + Tạo yêu cầu để bắt đầu.",
      "errorPrefix": "Lỗi tải dữ liệu: {{message}}",
      "loading": "Đang tải payment requests…",
      "retry": "Thử lại"
    },
    "page": {
      "description": "Yêu cầu hoàn tiền / tín dụng off-platform từ Printway. Admin xử lý thủ công hoặc tự động (theo rule).",
      "title": "Yêu cầu thanh toán"
    },
    "pagination": {
      "next": "Trang sau",
      "prev": "Trang trước",
      "showing": "Hiển thị {{from}}–{{to}} trên {{total}} yêu cầu · Trang {{page}} / {{totalPages}}"
    },
    "status": {
      "approved": "Đã duyệt",
      "cancelled": "Đã huỷ",
      "paid": "Đã chi trả",
      "pending": "Đang chờ",
      "rejected": "Bị từ chối"
    },
    "table": {
      "actions": "Hành động",
      "amount": "Số tiền",
      "decidedAt": "Ngày xử lý",
      "number": "Mã yêu cầu",
      "requestedAt": "Ngày tạo",
      "status": "Trạng thái",
      "view": "Xem"
    },
    "toast": {
      "amountInvalidDesc": "Vui lòng nhập số dương.",
      "amountInvalidTitle": "Số tiền không hợp lệ",
      "createFailedTitle": "Tạo yêu cầu thất bại",
      "createdDesc": "Mã yêu cầu: {{number}}",
      "createdTitle": "Đã tạo yêu cầu",
      "purposeShortDesc": "Vui lòng mô tả chi tiết (tối thiểu 10 ký tự).",
      "purposeShortTitle": "Lý do quá ngắn"
    }
  },
  "receipts": {
    "deliveryStatus": {
      "failed": "Thất bại",
      "pending": "Đang chờ",
      "sent": "Đã gửi",
      "skipped": "Bỏ qua"
    },
    "download": {
      "aria": "Tải xuống biên lai {{receiptNumber}}",
      "button": "Tải xuống",
      "failedFallback": "Không thể tải xuống {{receiptNumber}}.",
      "failedTitle": "Tải xuống thất bại"
    },
    "errors": {
      "loadFailed": "Không tải được biên lai."
    },
    "filters": {
      "dateFrom": {
        "aria": "Lọc biên lai phát hành từ ngày này trở đi",
        "label": "Từ ngày"
      },
      "dateTo": {
        "aria": "Lọc biên lai phát hành trước hoặc trong ngày này",
        "label": "Đến ngày"
      },
      "delivery": {
        "all": "Tất cả trạng thái gửi",
        "aria": "Lọc biên lai theo trạng thái gửi email",
        "label": "Gửi email"
      },
      "direction": {
        "aria": "Chiều sắp xếp biên lai",
        "asc": "Tăng dần (cũ nhất / nhỏ nhất trước)",
        "desc": "Giảm dần (mới nhất / lớn nhất trước)",
        "label": "Chiều"
      },
      "sort": {
        "aria": "Trường sắp xếp biên lai",
        "label": "Sắp xếp theo"
      },
      "source": {
        "all": "Tất cả nguồn",
        "aria": "Lọc biên lai theo nguồn nạp tiền",
        "label": "Nguồn"
      }
    },
    "header": {
      "description": "Mỗi lần nạp tiền thành công có một biên lai PDF — tự động với cổng tức thời (Cấp 1) và sau khi quản trị viên duyệt với nạp tiền thủ công (Cấp 2). Biên lai là chứng từ thuế được lưu giữ trong 7 năm.",
      "title": "Biên lai nạp tiền"
    },
    "pagination": {
      "next": "Sau",
      "nextAria": "Trang biên lai sau",
      "prev": "Trước",
      "prevAria": "Trang biên lai trước",
      "summary": "Trang {{page}} trên {{totalPages}} — {{total}} biên lai"
    },
    "sortField": {
      "amount": "Số tiền",
      "issued_at": "Ngày phát hành",
      "receipt_number": "Số biên lai"
    },
    "sourceType": {
      "TOPUP_TIER1": "Cấp 1 (Tự động)",
      "TOPUP_TIER2": "Cấp 2 (Thủ công)"
    },
    "states": {
      "emptyBody": "Biên lai sẽ xuất hiện ở đây sau khi nạp tiền thành công. Hãy thử mở rộng bộ lọc phía trên.",
      "emptyTitle": "Chưa có biên lai",
      "loading": "Đang tải biên lai…"
    },
    "table": {
      "action": "Hành động",
      "amount": "Số tiền",
      "delivery": "Gửi email",
      "issued": "Phát hành",
      "receiptNumber": "Số biên lai",
      "source": "Nguồn"
    }
  },
  "settingsTabs": {
    "alertHistory": {
      "allChannels": "Tất cả kênh",
      "allStatuses": "Tất cả trạng thái",
      "firstPageAria": "Trang đầu",
      "lastPageAria": "Trang cuối",
      "nextPageAria": "Trang sau",
      "prevPageAria": "Trang trước"
    },
    "alerts": {
      "channelEmail": "Thông báo qua email",
      "channelPush": "Thông báo đẩy",
      "thresholdSliderAria": "Thanh trượt ngưỡng cảnh báo",
      "title": "Cảnh báo số dư thấp",
      "subtitle": "Nhận thông báo khi số dư ví xuống dưới ngưỡng",
      "thresholdLabel": "Ngưỡng cảnh báo",
      "thresholdHelp": "Bạn sẽ được thông báo khi số dư xuống dưới mức này",
      "thresholdPlaceholder": "50",
      "channelsLegend": "Kênh thông báo",
      "channelsHelp": "Chọn cách bạn muốn nhận cảnh báo",
      "channelInApp": "Thông báo trong ứng dụng (luôn bật)",
      "emailRecipientsLabel": "Người nhận email (phân tách bằng dấu phẩy, tối đa 10)",
      "emailRecipientsPlaceholder": "owner@example.com, finance@example.com",
      "smsRecipientsLabel": "Người nhận SMS (E.164, tối đa 5)",
      "smsRecipientsPlaceholder": "+1415..., +84...",
      "cooldownLabel": "Thời gian chờ (giờ, 1-168)",
      "testTitle": "Cảnh báo thử",
      "testHelp": "Gửi cảnh báo thử để kiểm tra cài đặt của bạn hoạt động",
      "sendTest": "Gửi cảnh báo thử",
      "savedDesc": "Đã cập nhật cài đặt cảnh báo.",
      "errThreshold": "Ngưỡng phải là số không âm.",
      "errEmailInvalid": "Địa chỉ email không hợp lệ: {{value}}",
      "errEmailMax": "Tối đa 10 người nhận email.",
      "errSmsInvalid": "Số điện thoại E.164 không hợp lệ: {{value}}",
      "errSmsMax": "Tối đa 5 người nhận SMS.",
      "errCooldown": "Thời gian chờ phải từ 1 đến 168 giờ.",
      "testDispatchedTitle": "Đã gửi cảnh báo thử",
      "testDispatchedDesc": "{{ok}}/{{total}} kênh đã được xếp hàng để gửi.",
      "rateLimitTitle": "Đã đạt giới hạn tần suất",
      "noChannelsTitle": "Chưa cấu hình kênh",
      "testFailedTitle": "Gửi cảnh báo thử thất bại",
      "clientRateLimit": "Vui lòng đợi một lát trước khi gửi cảnh báo thử khác."
    },
    "autoTopup": {
      "pmPlaceholder": "UUID phương thức thanh toán",
      "title": "Tự động nạp",
      "subtitle": "Tự động nạp tiền vào ví khi số dư xuống dưới ngưỡng kích hoạt.",
      "triggerLabel": "Ngưỡng kích hoạt (nạp khi số dư xuống dưới)",
      "triggerPlaceholder": "50.00",
      "amountLabel": "Số tiền nạp (nạp mỗi lần)",
      "amountPlaceholder": "500.00",
      "dailyLabel": "Giới hạn ngày (tùy chọn)",
      "dailyPlaceholder": "1000.00",
      "monthlyLabel": "Giới hạn tháng (tùy chọn)",
      "monthlyPlaceholder": "5000.00",
      "pmLabel": "Phương thức thanh toán (tài khoản liên kết)",
      "pmSelectEmpty": "— Chọn phương thức thanh toán đã xác minh —",
      "pmUnverified": "(chưa xác minh)",
      "pmManageHelp": "Quản lý tài khoản liên kết tại {{path}}.",
      "errTrigger": "Ngưỡng kích hoạt phải là số không âm.",
      "errAmountPositive": "Số tiền nạp phải lớn hơn 0.",
      "errAmountDaily": "Số tiền nạp phải ≤ giới hạn ngày.",
      "errDailyMonthly": "Giới hạn ngày phải ≤ giới hạn tháng.",
      "errPmRequired": "Chọn phương thức thanh toán để bật tự động nạp.",
      "errLimitExceeded": "Số tiền nạp vượt quá giới hạn ngày đã cấu hình.",
      "errPmNotVerified": "Phương thức thanh toán phải được xác minh trước khi bật tự động nạp.",
      "errPmNotFound": "Không tìm thấy phương thức thanh toán.",
      "concurrentTitle": "Phát hiện chỉnh sửa đồng thời",
      "concurrentDesc": "Cài đặt đã bị thay đổi ở nơi khác. Đang tải lại giá trị mới nhất…",
      "savedDesc": "Đã cập nhật cài đặt tự động nạp."
    },
    "nav": {
      "breadcrumbAria": "Đường dẫn điều hướng",
      "sectionsAria": "Các mục cài đặt thanh toán",
      "crumbBilling": "Thanh toán",
      "crumbSettings": "Cài đặt"
    },
    "taxDocs": {
      "filterByYearAria": "Lọc tài liệu thuế theo năm"
    },
    "page": {
      "title": "Cài đặt thanh toán",
      "subtitle": "Cấu hình cảnh báo ví, tự động nạp tiền và tùy chọn thông báo"
    },
    "loading": "Đang tải…",
    "tabs": {
      "alerts": "Cảnh báo",
      "autoTopup": "Tự động nạp",
      "history": "Lịch sử cảnh báo",
      "receipts": "Biên nhận",
      "tax": "Chứng từ thuế"
    },
    "common": {
      "enabled": "Bật",
      "disabled": "Tắt",
      "save": "Lưu thay đổi",
      "saving": "Đang lưu…",
      "sending": "Đang gửi…",
      "savedTitle": "Đã lưu",
      "saveFailedTitle": "Lưu thất bại",
      "networkError": "Lỗi mạng — kiểm tra kết nối"
    }
  },
  "spendingChart": {
    "ariaLabel": "Biểu đồ cột chồng thể hiện chi tiêu {{window}} ngày gần đây",
    "empty": "Chưa có dữ liệu chi tiêu.",
    "emptyWindow": "Chưa có dữ liệu chi tiêu trong {{window}} ngày qua",
    "error": "Không tải được giao dịch ({{message}}).",
    "footer": {
      "label": "Tổng chi tiêu (outflow) {{window}} ngày:"
    },
    "loading": "Đang tải dữ liệu chi tiêu…",
    "series": {
      "embroidery": "Thêu",
      "order": "Đơn hàng",
      "surcharge": "Phụ phí",
      "topup": "Nạp tiền",
      "withdraw": "Rút tiền"
    },
    "title": "Chi tiêu {{window}} ngày gần đây",
    "tooltip": {
      "total": "{{day}} — Tổng {{amount}}"
    },
    "unknownError": "không xác định"
  },
  "history": {
    "allChannels": "Tất cả kênh",
    "allStatuses": "Tất cả trạng thái",
    "from": "Từ ngày",
    "to": "Đến ngày",
    "channel": "Kênh",
    "status": "Trạng thái",
    "chanEmail": "Email",
    "chanSms": "SMS",
    "chanPush": "Đẩy",
    "chanInapp": "Trong ứng dụng",
    "statusSent": "Đã gửi",
    "statusFailed": "Thất bại",
    "statusBounced": "Bị trả lại",
    "statusPending": "Đang chờ",
    "apply": "Áp dụng bộ lọc",
    "reset": "Đặt lại",
    "exportCsv": "Xuất CSV",
    "exporting": "Đang xuất…",
    "colDate": "Ngày",
    "colChannel": "Kênh",
    "colRecipient": "Người nhận",
    "colThreshold": "Ngưỡng",
    "colBalance": "Số dư",
    "colStatus": "Trạng thái",
    "loading": "Đang tải lịch sử cảnh báo…",
    "error": "Không tải được lịch sử cảnh báo.",
    "empty": "Không có cảnh báo trong khoảng đã chọn.",
    "showing": "Hiển thị {{start}}-{{end}} trên {{total}} bản ghi",
    "pageOf": "Trang {{page}} trên {{total}}",
    "firstPageAria": "Trang đầu",
    "prevPageAria": "Trang trước",
    "nextPageAria": "Trang sau",
    "lastPageAria": "Trang cuối",
    "exportOkTitle": "Xuất sẵn sàng",
    "exportOkBody": "Tệp CSV của bạn đang được tải xuống.",
    "exportFailTitle": "Xuất thất bại",
    "exportFailBody": "Không thể xuất lịch sử cảnh báo. Hãy thử thu hẹp bộ lọc."
  },
  "tax": {
    "filterByYearAria": "Lọc tài liệu thuế theo năm",
    "title": "Gói tài liệu thuế hằng tháng",
    "subtitle": "Tải các gói thuế hằng tháng (CSV trong ZIP) để lưu trữ.",
    "year": "Năm",
    "colPeriod": "Kỳ",
    "colEntity": "Pháp nhân",
    "colStatus": "Trạng thái",
    "colFiles": "Số tệp",
    "colSize": "Kích thước",
    "colGenerated": "Đã tạo",
    "colAction": "Hành động",
    "loading": "Đang tải tài liệu thuế…",
    "error": "Không tải được tài liệu thuế.",
    "emptyTitle": "Chưa có tài liệu thuế",
    "emptyBody": "Các gói thuế hằng tháng của năm {{year}} sẽ xuất hiện ở đây khi được tạo.",
    "download": "Tải xuống",
    "preparing": "Đang chuẩn bị…",
    "statusReady": "Sẵn sàng",
    "statusFailed": "Thất bại",
    "statusGenerating": "Đang tạo",
    "statusPending": "Đang chờ",
    "downloadAria": "Tải gói thuế cho {{period}}",
    "disclaimer": "Các tài liệu này được cung cấp cho mục đích kế toán và khai thuế của bạn. Printway không cung cấp tư vấn thuế. Vui lòng tham khảo cố vấn thuế có chuyên môn tại khu vực pháp lý của bạn.",
    "toastStartedTitle": "Đã bắt đầu tải xuống",
    "toastStartedBody": "Gói {{period}} ({{size}})",
    "toastFailTitle": "Tải xuống thất bại",
    "toastNotReadyTitle": "Gói vẫn đang được tạo",
    "toastFailBody": "Không thể tải gói {{period}} — hãy thử lại sau."
  }
}
